import React, { useEffect, useState } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import PartnerComponent from "../../components/partner/PartnerComponent";
import Loading from "../../../components/isLoading";
import { fetchPartnerData } from "../../../redux/partners";
import { Edit, Publish } from "@material-ui/icons";
import { toast } from "react-toastify";
import actionCreator from "../../../redux/action/actionCreator";
import { DeleteForever } from "@mui/icons-material";
import DeleteModel from "../DeleteModel";
import ConfirmModel from "../ConfirmModel";
import { DELETE_PARTNER } from "../../../redux/partners/types";

const PartnerContainer = (props) => {
  const { id } = props;
  const [state, setState] = useState({
    openDeleteMessage: false,
    openConfirmation: false,
  });
  const navigate = useNavigate();

  const partnerData = useSelector((state) => state.partnerGlobalStore);
  const deleteStore = useSelector((store) => store.deletePartnerGlobalStore);
  const dispatch = useDispatch();

  useEffect(() => {
    if (id && id !== partnerData.data.id) {
      dispatch(fetchPartnerData(id));
    }
  }, []);

  const handleOnEdit = () => navigate("edit");

  const handleOpenCloseConfirmModel = (condition) =>
    setState((prevState) => ({ ...prevState, openConfirmation: condition }));

  const handleOpenCloseDeleteModel = (condition) =>
    setState((prevState) => ({ ...prevState, openDeleteMessage: condition }));

  const handleDeletePartner = async () => {
    await toast.promise(
      dispatch(
        actionCreator({
          method: "DELETE",
          path: `/api/partners/${id}`,
          actionType: DELETE_BLOG,
        })
      ),
      {
        pending: "Deleting Partner",
        success: deleteStore.message
          ? deleteStore.message
          : "Partner successfully deleted",
        error: `Unable to delete Partner`,
      }
    );
    handleOpenCloseDeleteModel(false);
  };
  const isUnpublish = partnerData.data?.status === "published";
  const crumps = [
    {
      title: "Partners",
      path: "/partners",
    },
  ];
  const actions = [
    {
      onClick: handleOnEdit,
      text: "Edit Partner",
      icon: <Edit fontSize="small" />,
    },
    {
      onClick: () => handleOpenCloseConfirmModel(true),
      text: isUnpublish ? "Unpublish Partner" : "Publish Partner",
      icon: <Publish fontSize="small" />,
    },
    {
      onClick: () => handleOpenCloseDeleteModel(true),
      text: "Delete Partner",
      icon: <DeleteForever fontSize="small" />,
    },
  ];

  return partnerData.loading ? (
    <Loading />
  ) : (
    <div>
      <DeleteModel
        isOpen={state.openDeleteMessage}
        isFor="Partners"
        handleCloseModel={() => handleOpenCloseDeleteModel(false)}
        itemId={id}
        store={deleteStore}
        action={DELETE_PARTNER}
      />
      <ConfirmModel
        isOpen={state.openConfirmation}
        isFor="Partners"
        handleCloseModel={handleOpenCloseConfirmModel}
        itemId={id}
        isUnpublish={isUnpublish}
      />
      <PartnerComponent
        partnerDetails={partnerData.data || {}}
        crumps={crumps}
        actions={actions}
      />
    </div>
  );
};

export default PartnerContainer;
